import { BotDialog } from 'components/BotDialog';
import {
  BotDialogPill,
  BotDialogButtonsContainer,
  BotDialogButtonOutline,
} from 'components/BotDialog/BotDialog.styles';
import { List } from './BotDialogBlockedWords.styles';

export default function BotDialogBlockedWords({ blockedWords, onCancel, show = false }) {
  return (
    <BotDialog
      show={show}
      title="Warning: Blocked Words"
      description={`You have entered the following blocked word(s). Please review the list below and remove the words from your message:`}
    >
      <List as="ul">
        {blockedWords.map((word) => (
          <BotDialogPill key={word} as="li" children={word} />
        ))}
      </List>
      <BotDialogButtonsContainer>
        <BotDialogButtonOutline onClick={onCancel}>Go Back</BotDialogButtonOutline>
      </BotDialogButtonsContainer>
    </BotDialog>
  );
}
